export const contactsData = {
    email: 'akshaygosavi621@gmail.com',
    address: 'Kalyan, Maharashtra, India',
    github: 'https://github.com/akkisavi',
    linkedIn: 'https://linkedin.com/in/agosavi621',
    sheetAPI: ''
};
